import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const RouteFocus = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const returnLinks = useRef(new Map());

  useLayoutEffect(() => {
    // Remember the link that led away, so Back resumes keyboard reading there.
    const rememberLink = event => {
      const link = event.target.closest('a[href]');
      if (link) returnLinks.current.set(location.key, {
        href: link.getAttribute('href'),
        text: link.textContent,
      });
    };
    let target;
    if (navigationType === 'POP') {
      const saved = returnLinks.current.get(location.key);
      if (saved) target = Array.from(document.querySelectorAll('a[href]')).find(link =>
        link.getAttribute('href') === saved.href && link.textContent === saved.text
      );
    } else {
      const hash = location.hash.slice(1);
      const hashEl = hash ? document.getElementById(hash) : null;
      target = hashEl || document.querySelector('h1');
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      if (hashEl) {
        requestAnimationFrame(() => {
          hashEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
    target?.focus({ preventScroll: true });
    document.addEventListener('focusin', rememberLink);
    return () => document.removeEventListener('focusin', rememberLink);
  }, [location.key, location.hash, navigationType]);

  return null;
};

export default RouteFocus;
